import React, { useState } from "react";
import SkuInventoryIndex from "./Component/SkuInventory/SkuInventoryIndex";
import ProductInventoryIndex from "./Component/ProductInventory/ProductInventoryIndex";
import { useDispatch } from "react-redux";

function InventoryIndex() {
  const [tab, setTab] = useState(1);
  

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8 space-y-6">
      <div className="flex items-center space-x-4">
        <ul
          className="text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar border-b border-b-[#D9D9D9] space-x-12 grow"
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="text-left flex items-center ">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 1 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(1)}
            >
              Stock Keeping Units (SKUs)
            </a>
          </li>
          <li className="text-left flex items-center">
            <a
              className={`w-full block whitespace-nowrap text-sm leading-3 font-semibold py-2 cursor-pointer ${
                tab === 2 && "border-b-2 border-[--bg-color-500] text-[--bg-color-500]"
              }`}
              onClick={() => setTab(2)}
            >
              Products
            </a>
          </li>
        </ul>
      </div>
      {tab === 1 && <SkuInventoryIndex />}
      {tab === 2 && <ProductInventoryIndex />}
    </div>
  );
}

InventoryIndex.auth = {
  path: "/inventory/overview",
  role: "super-admin admin",
};
export default InventoryIndex;
